'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');
var listStrategy = require('./listStrategy.js');

var ListContext = react.createContext({
    getSortBy: function () { return null; },
    sortList: function (sortBy, sortType, sortDirection) { return null; },
    getSortDirection: function () { return 1; },
    getCurrentPage: function () { return 1; },
    getNumPages: function () { return 1; },
    getItemsPerPage: function () { return 1; },
    setCurrentPage: function (currentPage, records) { return null; },
    filterList: function (filter) { return null; },
    setItemsPerPage: function (itemsPerPage) { return null; },
    getList: function () { return []; },
    setList: function (list) { return null; },
    getColumns: function () { return []; },
    listStrategy: listStrategy.ListStrategyType.CLIENT_SIDE,
    listSize: 0
});
var ListContext$1 = ListContext;

exports.default = ListContext$1;
//# sourceMappingURL=ListContext.js.map
